/**
 * Uses the TrustPilot attribute data to build the HTML markup for the "size" attribute range slider
 * @param {String} data - Contains the TrustPilot attribute data to build the range slider
 * @returns {Element} - The HTML markup of the range slider to display
 */
const getTrustPilotAttributeSummariesMarkup = (data) => {
    const sizeRangeAttr = data.find(attr => attr.name.toLowerCase() === "size");
    const labelsString = $(".reviews-range-displays").attr("data-review-labels");
    const labelsObject = labelsString.split(",").reduce((acc, pair) => {
        const [key, value] = pair.split(":").map(item => item.trim());
        acc[key] = value;
        return acc;
    }, {});

    if (sizeRangeAttr) {
        let sizeRangeAttrTextValue;
        switch (true) {
            case (sizeRangeAttr.average < 1.5):
                sizeRangeAttrTextValue = labelsObject.verySmall;
                break;
            case (sizeRangeAttr.average < 2.5):
                sizeRangeAttrTextValue = labelsObject.slightlySmall;
                break;
            case (sizeRangeAttr.average < 3.5):
                sizeRangeAttrTextValue = labelsObject.asExpected;
                break;
            case (sizeRangeAttr.average < 4.5):
                sizeRangeAttrTextValue = labelsObject.slightlyLarge;
                break;
            default:
                sizeRangeAttrTextValue = labelsObject.veryLarge;
        }

        return `
            <div class="rating-display">
                <label for="sizeRating">${labelsObject.trueToSize}</label>
                <input
                    id="sizeRating"
                    class="rating-display-range"
                    type="range"
                    value="${sizeRangeAttr.average}"
                    min="1"
                    max="5"
                    disabled
                    aria-labelledby="size-labels"
                    aria-valuemin="1"
                    aria-valuemax="5"
                    aria-valuenow="${sizeRangeAttr.average}"
                    aria-valuetext="${sizeRangeAttrTextValue}">

                <!-- Visual labels -->
                <div id="size-labels" class="range-labels">
                    <span class="range-label" aria-hidden="true">${labelsObject.small}</span>
                    <span class="range-label" aria-hidden="true">${labelsObject.perfect}</span>
                    <span class="range-label" aria-hidden="true">${labelsObject.large}</span>
                </div>
            </div>
        `;
    }
};

/**
 * Uses the TrustPilot attribute data to output the attribute range slider
 * @param {String} data - Contains the TrustPilot attribute data to build the range slider
 * @param {Element} container - Parent element to append the attribute range slider to
 * @returns {void}
 */
const displayTrustPilotAttributeSummaries = (data, container) => {
    if (data?.result?.attributeSummariesResult?.attributeSummaries) {
        container.prepend(getTrustPilotAttributeSummariesMarkup(data?.result?.attributeSummariesResult?.attributeSummaries));
    }
};

// Listen for the event triggered from product/detail.js
$("body").on("product:displayTrustPilotAttributeSummaries", function (event, data) {
    displayTrustPilotAttributeSummaries(data.data, data.container);
});

module.exports = {
    displayTrustPilotAttributeSummaries
};
